import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '../headers/ModalHeader';

const AppInProgressModal = props => {
    const {
        modalHeaderProps
    } = props;

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideCloseIcon: true }} />
            </div>
            <div className="gi-modal__body" id={`${modalHeaderProps.modalId}_body`}>
                <p>
                    <FormattedMessage id="app_in_progress_modal_body"/>
                </p>
            </div>
        </Fragment>
    );
};

export default AppInProgressModal;
